import React, { useEffect, useState } from "react";
import SubscriptionCard from "./SubscriptionCard";
import { useDispatch, useSelector } from "react-redux";
import { fetchListSubscription } from "store/slices/subscription";
import ComponentLoading from "components/Common/ComponentLoading";
import { Box, Grid, makeStyles } from "@material-ui/core";
import AppButton from "components/CustomButtons/AppButton";
import { useTranslation } from "react-i18next";
import { getAuthInfo } from "store/slices/auth";
import { SYSTEM_ROLE } from "config/AppConfig";
import moment from "moment";
const MONTH_OR_YEAR = {
  MONTH: "MONTH",
  YEAR: "YEAR",
};
const SubscriptionList = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [recurring, setRecurring] = useState(MONTH_OR_YEAR.MONTH);

  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const userInfo = useSelector(getAuthInfo);
  const [isExpired, setIsExpired] = useState(false);

  const { companySubcriptionExpiryDate, companySubscriptionId } = userInfo;

  useEffect(() => {
    const interval = setInterval(() => {
      if (userInfo && userInfo.role === SYSTEM_ROLE.COMPANY && companySubcriptionExpiryDate) {
        const _expiredDate = moment(companySubcriptionExpiryDate);
        const currentDate = moment();
        if(_expiredDate.diff(currentDate) > 0) {
          setIsExpired(false);
        } else {
          setIsExpired(true);
          clearInterval(interval);
        }
      }
    }, 100);
  }, []);

  const _loadData = async (recurring) => {
    setRecurring(recurring);
    setLoading(true);
    const result = await dispatch(
      fetchListSubscription({ recurring: recurring })
    );
    setLoading(false);
    if (result.payload) {
      setList(result.payload);
    }
  };
  useEffect(() => {
    _loadData(MONTH_OR_YEAR.MONTH);
  }, []);

  const useStyles = makeStyles(() => ({
    buttonClick: {
      color: recurring === MONTH_OR_YEAR.MONTH ? "" : "#000000",
      backgroundColor: recurring === MONTH_OR_YEAR.MONTH ? "" : "#DEDEDE",
      "&:hover": {
        color: "#000000",
        backgroundColor: "#59D5B2",
        opacity: '0.8' 
      }
    },
    button: {
      color: recurring === MONTH_OR_YEAR.YEAR ? "" : "#000000",
      backgroundColor: recurring === MONTH_OR_YEAR.YEAR ? "" : "#DEDEDE",
      "&:hover": {
        color: "#000000",
        backgroundColor: "#59D5B2",
        opacity: '0.8' 

      }
    }
  }))
  const classes = useStyles();
  return (
    <React.Fragment>
      <Box style={{ display: 'flex', justifyContent: 'center' }}>
        <AppButton
          label={t('button.pay_monthly')}
          className={classes.buttonClick}
          style={{
            color: recurring === MONTH_OR_YEAR.MONTH ? "" : "#000000",
            backgroundColor:  recurring === MONTH_OR_YEAR.MONTH ? "" : "#DEDEDE",
          }}
          onClick={() => _loadData(MONTH_OR_YEAR.MONTH)}
        />
        <AppButton
          label={t('button.pay_annual')}
          className={classes.button}

          style={{
            color: recurring === MONTH_OR_YEAR.YEAR ? "" : "#000000",
            backgroundColor:  recurring === MONTH_OR_YEAR.YEAR ? "" : "#DEDEDE",
          }}
          onClick={() => _loadData(MONTH_OR_YEAR.YEAR)}
        />
      </Box>
      {loading &&
      <Box style={{ marginTop: '50px'}}>
        <ComponentLoading />
      </Box>
      }
      <Grid container spacing={3} style={{ marginTop: '20px'}}>
        {!loading && list.map(item => (
          <Grid item xs={3}  key={item.id}>
            <SubscriptionCard
              key={item.id}
              subscriptionId={item.id}
              featureDescription={item.featureDescription}
              totalWorker={item.numberWorker}
              totalClient={item.numberClient}
              packageName={item.packageName}
              price={item.pricing}
              recurring={item.recurring}
              expiredDate={(companySubscriptionId === item.id && !isExpired) ? companySubcriptionExpiryDate : ""}
              freePackage={item.freePackage}
            />
          </Grid>
        ))}
        <Grid item xs={12}/>
      </Grid>
    </React.Fragment>
  );
};

export default SubscriptionList;
